import * as React from 'react';
import './SaveOptions.css';

export interface SaveOptionsProps {
  saveEmailChecked: boolean;
  saveAttachmentsChecked: boolean;
  saveToCrmChecked: boolean;
  isOutgoingEmail: boolean;
  attachmentCount: number;
  isProcessing: boolean;
  onToggleSaveEmail: () => void;
  onToggleSaveAttachments: () => void;
  onToggleSaveToCrm: () => void;
}

const SaveOptions: React.FC<SaveOptionsProps> = ({
  saveEmailChecked,
  saveAttachmentsChecked,
  saveToCrmChecked,
  isOutgoingEmail,
  attachmentCount,
  isProcessing,
  onToggleSaveEmail,
  onToggleSaveAttachments,
  onToggleSaveToCrm,
}) => {
  return (
    <div className="form-section">
      <label className="form-label">Opslaan in sharepoint</label>
      <div className="checkbox-group">
        <label className={`checkbox-item ${isOutgoingEmail ? 'checkbox-item--disabled' : ''}`}>
          <input
            type="checkbox"
            checked={saveEmailChecked}
            onChange={onToggleSaveEmail}
            disabled={isProcessing || isOutgoingEmail}
          />
          <span>E-mail opslaan{isOutgoingEmail && ' (niet beschikbaar voor verzonden items)'}</span>
        </label>
        <label className={`checkbox-item ${isOutgoingEmail ? 'checkbox-item--disabled' : ''}`}>
          <input
            type="checkbox"
            checked={saveAttachmentsChecked}
            onChange={onToggleSaveAttachments}
            disabled={isProcessing || attachmentCount === 0 || isOutgoingEmail}
          />
          <span>Bijlagen opslaan{isOutgoingEmail && ' (niet beschikbaar voor verzonden items)'}</span>
        </label>
        <label className="checkbox-item">
          <input
            type="checkbox"
            checked={saveToCrmChecked}
            onChange={onToggleSaveToCrm}
            disabled={isProcessing}
          />
          <span>E-mail opslaan in CRM</span>
        </label>
      </div>
      {!saveEmailChecked && !saveAttachmentsChecked && !saveToCrmChecked && (
        <div className="info-banner warning info-banner--save-options">
          <span className="material-icons-round banner-icon">warning</span>
          <div className="banner-content">
            <p className="banner-text">Selecteer minimaal één optie om op te slaan.</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default SaveOptions;
